export const isOrgPortal = () => { try { return localStorage.getItem("lx_portal") === "org"; } catch (e) { return false; } };
export const setOrgPortal = (on) => { try { on ? localStorage.setItem("lx_portal", "org") : localStorage.removeItem("lx_portal"); } catch (e) { /* ignore */ } };
